// Copyright (c) 2026 Otyka LLC. All rights reserved.

import React from 'react';
import './Header.css';

export default function Header({ activeView, onSwitchView, branding }) {
  const clubName = branding?.clubName || 'Member Feedback';
  const tagline = branding?.tagline || 'Your voice shapes the experience';
  const logoUrl = branding?.logoUrl || null;

  return (
    <header className="header">
      <div className="header__inner">
        <div className="header__brand">
          {logoUrl ? (
            <img src={logoUrl} alt={`${clubName} logo`} className="header__logo" />
          ) : (
            <div className="header__crest" aria-hidden="true">⛳</div>
          )}
          <div className="header__text">
            <h1 className="header__title">{clubName}</h1>
            <p className="header__subtitle">{tagline}</p>
          </div>
        </div>

        {onSwitchView && (
          <nav className="header__nav" aria-label="App navigation">
            <button
              className={`header__nav-btn${activeView === 'feedback' ? ' header__nav-btn--active' : ''}`}
              onClick={() => onSwitchView('feedback')}
              aria-current={activeView === 'feedback' ? 'page' : undefined}
            >
              Submit Feedback
            </button>
            <button
              className={`header__nav-btn${activeView === 'insights' ? ' header__nav-btn--active' : ''}`}
              onClick={() => onSwitchView('insights')}
              aria-current={activeView === 'insights' ? 'page' : undefined}
            >
              Insights
            </button>
          </nav>
        )}
      </div>
    </header>
  );
}
